import styled from 'styled-components';

export const Svg = styled.svg`
  display: inline-block;
  width: 1em;
`;
